import { Modal } from '@seiue/ui'
import { createEnumHelper } from '@seiue/util'

import {
  StatusEnum,
  Notification,
  ReflectionTypeEnum,
  UserForegroundDomainEnum,
} from 'packages/sdks-next/growp'

import { EditNotificationModal } from '../../features/activities/pages/Detail/Notification/EditNotificationModal'

export const noticeStatusToLabel = createEnumHelper(() => ({
  [StatusEnum.Published]: '已发送',
  [StatusEnum.Unpublished]: '待发送',
  [StatusEnum.Withdrawn]: '已撤回',
}))

export const noticeStatusToTagStatus = createEnumHelper(() => ({
  [StatusEnum.Published]: 'success' as const,
  [StatusEnum.Unpublished]: 'warning' as const,
  [StatusEnum.Withdrawn]: 'invalid' as const,
}))

/**
 * 打开编辑通知弹窗
 *
 * @param param0 - 参数
 * @param param0.notification - 通知
 * @param param0.activityId - 活动 ID
 * @param param0.reflectionType -  人员类型
 */
export const openEditNotificationModal = ({
  notification,
  activityId,
  reflectionType,
}: {
  activityId: number
  notification?: Notification
  reflectionType?: ReflectionTypeEnum
}) => {
  const { hide } = Modal.open({
    header: null,
    footer: null,
    fullScreen: true,
    children: (
      <EditNotificationModal
        notification={notification}
        onClose={() => hide()}
        activityId={activityId}
        reflectionType={reflectionType}
      />
    ),
  })
}

/**
 * reflectionTypeToDomain
 *
 * @param reflectionType - ReflectionTypeEnum
 * @returns UserForegroundDomainEnum
 */
export const reflectionTypeToDomain = (reflectionType: ReflectionTypeEnum) => {
  return [
    ReflectionTypeEnum.FormalStudent,
    ReflectionTypeEnum.FormalTeacher,
  ].includes(reflectionType)
    ? UserForegroundDomainEnum.Formal
    : UserForegroundDomainEnum.Informal
}
